// Modules
import {
  Action,
  MetaReducer,
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
} from '@ngrx/store';

// Constants
import { APP_PATHS_CONSTANTS } from '@shared/constants';

// Store - Reducers
import * as AuthReducer from './auth.reducer';
import * as GeneralReducer from './general.reducer';
import * as DashboardReducer from './dashboard.reducer';
import * as ViewProfileReducer from './view-profile.reducer';
import * as ForcedPasswordChangeReducer from './forced-password-change.reducer';

// Store - Actions
import * as AuthActions from '@store/actions/auth.actions';

export interface AppState {
  auth: AuthReducer.AuthState;
  general: GeneralReducer.GeneralState;
  dashboardAutoStatistics: DashboardReducer.DashboardAutoStatisticsState;
  viewProfile: ViewProfileReducer.ViewProfileState;
  forcedPasswordChange: ForcedPasswordChangeReducer.ForcedPasswordChangeState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: AuthReducer.reducer,
  general: GeneralReducer.reducer,
  dashboardAutoStatistics: DashboardReducer.reducer,
  viewProfile: ViewProfileReducer.reducer,
  forcedPasswordChange: ForcedPasswordChangeReducer.reducer,
};

// Method to clear ngrx store once the user is logged out
export function clearState(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return function (state: AppState | undefined, action: Action): AppState {
    if (action.type === AuthActions.logoutSuccessful.type) state = undefined;
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearState];

// Feature Selector

export const getModuleState = createFeatureSelector<AppState>(
  APP_PATHS_CONSTANTS.DASHBOARD_AUTO
);

export const getModuleStateProfile = createFeatureSelector<AppState>(
  APP_PATHS_CONSTANTS.VIEW_PROFILE
);

/*

// Meta Reducer
export const metaReducers: MetaReducer<ModuleState>[] = [clearState];

// Feature Selector
export const getModuleState = createFeatureSelector<ModuleState>(FEATURE_STORE_KEY);
*/
